import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Stack
} from '@mui/material';
import { Add, Edit, Delete } from '@mui/icons-material';
import * as vatService from '../services/vatService';

const VATSettings = () => {
  const [vatRates, setVatRates] = useState([]);
  const [open, setOpen] = useState(false);
  const [editVat, setEditVat] = useState(null);
  const [percentage, setPercentage] = useState('');

  const fetchVatRates = async () => {
    const data = await vatService.getVatRates();
    setVatRates(data);
  };

  useEffect(() => {
    fetchVatRates();
  }, []);

  const handleSave = async () => {
    if (editVat) {
      await vatService.updateVatRate(editVat.Id, { VATPercentage: percentage });
    } else {
      await vatService.addVatRate({ VATPercentage: percentage });
    }
    await fetchVatRates();
    setOpen(false);
    setEditVat(null);
    setPercentage('');
  };

  const handleDelete = async (id) => {
    await vatService.deleteVatRate(id);
    await fetchVatRates();
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="flex-end" sx={{ mb: 2 }}>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => {
            setOpen(true);
            setEditVat(null);
            setPercentage('');
          }}
        >
          Add VAT Rate
        </Button>
      </Stack>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Percentage</TableCell>
            <TableCell align="right">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {vatRates?.payload?.map((rate) => (
            <TableRow key={rate.Id}>
              <TableCell>{rate.VATPercentage}%</TableCell>
              <TableCell align="right">
                <IconButton
                  onClick={() => {
                    setEditVat(rate);
                    setPercentage(rate.VATPercentage);
                    setOpen(true);
                  }}
                >
                  <Edit />
                </IconButton>
                <IconButton color="error" onClick={() => handleDelete(rate.Id)}>
                  <Delete />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>{editVat ? 'Edit VAT Rate' : 'Add VAT Rate'}</DialogTitle>
        <DialogContent>
          <TextField
            label="Percentage"
            type="number"
            value={percentage}
            onChange={e => setPercentage(e.target.value)}
            fullWidth
            autoFocus
            InputProps={{ endAdornment: <span>%</span> }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleSave} variant="contained">Save</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default VATSettings;